export default function TelegramIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.1065 2.79863L10.4398 10.6168C10.3195 11.1667 9.99304 11.3041 9.5291 11.0464L7.00323 9.20783L5.78325 10.3763C5.64578 10.5137 5.54269 10.6168 5.26776 10.6168L5.45677 8.03939L10.1477 3.81242C10.3539 3.62341 10.0961 3.5375 9.83839 3.70932L4.0306 7.35208L1.53909 6.57886C0.989241 6.40703 0.989241 6.029 1.65937 5.77126L11.402 2.00823C11.866 1.85358 12.2612 2.11132 12.1065 2.79863Z"
        fill="white"
      />
    </svg>
  );
}
